import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { SevenFever_1Screen } from "../SevenFever/game_1Screen";
export class SevenFeverLink_1Screen extends SevenFever_1Screen {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "SevenFeverLink");
    }

}